import { UnitRequest } from '@gtpl/shared-models/common-models';
import { CommonResponse } from '@gtpl/shared-models/masters';
import { ConsumedQtyRequest, GetAllConsumptionItemsResponseModel, getAllStoreConsumptionsResponse, GetStoreConsumptionResponse, GetStoreConsumptionSosResponseModel, getStoreConsumptionsResponse, IssuesDropDownResponse, PlaceListPalletDto, SaleOrderIdRequest, StoreConsumptionDetails, StoreConsumptionReportResponse, StoreConsumptionResponse, UpdatePlaceListStatus } from '@gtpl/shared-models/procurement-management';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post, Req } from '@nestjs/common';
import { ApiBearerAuth, ApiTags } from '@nestjs/swagger';
import { IndentFormDto } from './dto/indent-form-for-material.dto';
import { IndentQuantityRequest, RequestforIndentItem, Requestforindentstatusupdate } from './dto/indent-form-request';
import { indentFormServices } from './indent-form-service';

@ApiTags('indentform')
@Controller('indentform')

export class IndentformController {
    constructor(private indentformService: indentFormServices, private readonly applicationExceptionHandler: ApplicationExceptionHandler) { }

      /**
     * to Create Store indentData Data
     * @param indentData 
     * @returns 
     */
       @Post('createIndentFormDetails')
       async createIndentFormDetails(@Body() Data: IndentFormDto): Promise<CommonResponse> {
           console.log(Data);
           try {
               return this.indentformService.createIndentFormDetails(Data, false);
           } catch (error) {
               console.log(Data);
   
               return this.applicationExceptionHandler.returnException(CommonResponse, error);
           }
       }
   
       /**
        * to Create Store indentData Data
        * @param indentData 
        * @returns 
        */
       @Post('/updateindentform')
       async updateindentform(@Body() dto: IndentFormDto,@Req() request:Request): Promise<CommonResponse> {
         try {
           return await this.indentformService.createIndentFormDetails(dto, true);
         } catch (error) {
           // return errorHandler(DestinationResponseModel, error);
           return this.applicationExceptionHandler.returnException(CommonResponse, error);
         }
       }
        @Post('getallindentitemDetails')
        async getallindentitemDetails(@Body() req:RequestforIndentItem): Promise<CommonResponse> {
            try {
                return this.indentformService.getallindentitemDetails(req);
            } catch (error) {    
                return this.applicationExceptionHandler.returnException(CommonResponse, error);
            }
        }
        @Post('getindentformdetails')
        async getindentformdetails(@Body() req:UnitRequest): Promise<CommonResponse> {
            try {
                return this.indentformService.getindentformdetails(req);
            } catch (error) {    
                return this.applicationExceptionHandler.returnException(CommonResponse, error);
            }
        }
        @Post('/getAllIndentdataforindentmaterialId')
        async getAllIndentdataforindentmaterialId(@Body() req: RequestforIndentItem): Promise<CommonResponse> {
            try {
                return await this.indentformService.getAllIndentdataforindentmaterialId(req);
            } catch (error) {
                return this.applicationExceptionHandler.returnException(CommonResponse,error)
            }
        }
        @Post('/getIndentsDropDown')
        async getIndentsDropDown(@Body() req:UnitRequest) : Promise<CommonResponse>{
            try {
                return await this.indentformService.getIndentsDropDown(req);
            } catch (error) {
                return this.applicationExceptionHandler.returnException(CommonResponse,error)
            }
        }
        @Post('/getIndentItemDetailsById')
        async getIndentItemDetailsById(@Body() req:RequestforIndentItem) : Promise<CommonResponse>{
            try {
                return await this.indentformService.getIndentItemDetailsById(req);
            } catch (error) {
                return this.applicationExceptionHandler.returnException(CommonResponse,error)
            }
        }
        @Post('/CancelIndentformaterialPreparation')
        async CancelIndentformaterialPreparation(@Body() req:Requestforindentstatusupdate) : Promise<CommonResponse>{
            try {
                return await this.indentformService.CancelIndentformaterialPreparation(req);
            } catch (error) {
                return this.applicationExceptionHandler.returnException(CommonResponse,error)
            }
        }
        @Post('/getQuantityValidationforIndent')
        async getQuantityValidationforIndent(@Body() req:IndentQuantityRequest) : Promise<CommonResponse>{
            try {
                return await this.indentformService.getQuantityValidationforIndent(req);
            } catch (error) {
                return this.applicationExceptionHandler.returnException(CommonResponse,error)
            }
        }
}